import { Link } from 'react-router-dom';

export default function Hero() {

    return (
        <section className="hero__section">
            <div>
                <h1 className="hero__title">Optimized Advertising</h1>
                <div className="hero-buttons">
                    <Link to="/advertisers" className="button-primary"><span>FOR ADVERTISERS</span></Link>
                    <Link to="/publishers" className="button-secondary"><span>FOR PUBLISHERS</span></Link>
                </div>
            </div>
        </section>
    )
}